@if (visible) {
  <div class="modal d-block" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content shadow">
        <div class="content">
          <div class="inner-content">
            <div class="header">
              <h3 class="title">{{ dialogTitle }}</h3>
              <span class="subtitle">{{ dialogSubtitle }}</span>
            </div>

            <!-- <div class="options"> -->
             <mat-radio-group aria-label="Select an option" >
             @for (opt of possibilities(); track $index; let index = $index)
             {
                <mat-radio-button [checked]="index == 0" (change)="updateValue(opt)" value="{{opt}}">{{opt}}</mat-radio-button>
             }
            </mat-radio-group>
            <!-- </div> -->

          </div>
          <div class="btn-row">
            <button
              appButton="secondary"
              type="button"
              (click)="onCancel()"
              >
              Cancel
            </button>
            <button
              type="button"
              appButton
              (click)="onConfirm()"
              >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
}
